import { Dialog, DialogContent, DialogHeader, DialogTitle } from "shared/ui/dialog"
import { WorkflowTimelinePanel } from "modules/permit/components/WorkflowTimelinePanel"
import type { PermitWorkflowTimeline } from "modules/permit"
import type { FC } from "react"

interface WorkflowTimelineDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  timeline: PermitWorkflowTimeline | null
  isLoading: boolean
  error: string | null
}

export const WorkflowTimelineDialog: FC<WorkflowTimelineDialogProps> = ({
  open,
  onOpenChange,
  timeline,
  isLoading,
  error,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto">
      <DialogHeader>
        <DialogTitle>สถานะการอนุมัติ</DialogTitle>
      </DialogHeader>
      <WorkflowTimelinePanel timeline={timeline} isLoading={isLoading} error={error} />
    </DialogContent>
  </Dialog>
)

